@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

.add-billable-work-modal {
	padding: (- Constants.$val-spacing-xl) Constants.$val-spacing-m;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: Constants.$val-spacing-s Constants.$val-spacing-l;

	&__date {
		width: 50%;
	}

	&__comment {
		height: 100%;
	}

	&__billing-code-placeholder {
		font-weight: normal;
		font-style: italic;
		color: Colors.$col-greyMid;
	}

	&__billing-code-item {
		margin-top: Constants.$val-spacing-m;
	}

	&__billing-code-group {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-xs;
	}

	&__billing-code-dropdown-item {
		max-width: 500px;
		white-space: normal;
		word-wrap: break-word;
		text-overflow: ellipsis;
		& > b {
			display: flex;
		}
	}

	&__info-def-item {
		display: flex;
		justify-content: space-between;
		align-items: center;

		&__unit-field{
			margin-left: Constants.$val-spacing-s;
			width: calc(100% - Constants.$val-spacing-s)
		}
	}

	&__add-field {
		color: Colors.$col-blue;
		cursor: pointer;
		margin-bottom: Constants.$val-spacing-s;

		& > [class^="icon-"] {
			font-size: Constants.$val-fontSizeBig;
			margin: 0 Constants.$val-spacing-s;
		}
	}
}

.dropdown_card_subtitle {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-greyInactive;
	margin-bottom: 0;
}

.dropdown_empty {
	color: Colors.$col-greyInactive;
	margin-bottom: 0;
}